export const SET_QUEUE_AUTHORS_FILTER = 'SET_QUEUE_AUTHORS_FILTER'
export const SET_QUEUE_KEYWORD_FILTER = 'SET_QUEUE_KEYWORD_FILTER'
export const SET_QUEUE_DRAFT_FILTER = 'SET_QUEUE_DRAFT_FILTER'
export const SET_QUEUE_STATUS_FILTER = 'SET_QUEUE_STATUS_FILTER'
export const SET_QUEUE_COURSE_FILTER = 'SET_QUEUE_COURSE_FILTER'
export const SET_QUEUE_LEVELS_FILTER = 'SET_REVIEW_QUEUE_LEVELS_FILTER'
export const CLEAR_QUEUE_FILTERS = 'CLEAR_QUEUE_FILTERS'
export const SET_QUEUE_TARGET_GRADE_LEVEL_FILTERS =
  'SET_QUEUE_TARGET_GRADE_LEVEL_FILTERS'

export function setAuthorsFilter(authorIds) {
  return {
    type: SET_QUEUE_AUTHORS_FILTER,
    payload: {
      authors_id_in: authorIds
    }
  }
}

export function setKeywordFilter(keyword) {
  return {
    type: SET_QUEUE_KEYWORD_FILTER,
    payload: {
      name_or_description_cont: keyword
    }
  }
}

export function setDraftFilter(val) {
  return {
    type: SET_QUEUE_DRAFT_FILTER,
    payload: {
      reviewing_compiled_quest_state_null: val
    }
  }
}

export function setStatusFilter(statuses) {
  return {
    type: SET_QUEUE_STATUS_FILTER,
    payload: {
      reviewing_compiled_quest_state_in: statuses
    }
  }
}

export function setCourseFilter(courseId) {
  return {
    type: SET_QUEUE_COURSE_FILTER,
    mock_course_id_in: courseId
  }
}

export function setLevelFilter(levels) {
  return {
    type: SET_QUEUE_LEVELS_FILTER,
    mock_level_id_in: levels
  }
}

export function clearQueueFilters() {
  return {
    type: CLEAR_QUEUE_FILTERS
  }
}

export function setTargetGradeLevelFilter(gradeLevels) {
  return {
    type: SET_QUEUE_TARGET_GRADE_LEVEL_FILTERS,
    grade_levels_id_in: gradeLevels
  }
}



// WEBPACK FOOTER //
// ./src/actions/queuefilters.js